// MODÜL 12: DÜNYA HAVAYOLLARI

const cabinCrewContentsM12 = {
  // ==================== KÖRFEZ HAVAYOLLARI ====================
  'CM-M12-U1-L1': {
    lesson_id: 'CM-M12-U1-L1',
    title: 'Emirates Airlines',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Emirates - Dubai\'nin Gururu',
      paragraphs: [
        'Emirates, 1985\'te Dubai hükümeti tarafından kuruldu. Dünyanın en büyük uluslararası havayolu.',
        'Hub: Dubai Uluslararası Havalimanı (DXB). Dünyanın en yoğun uluslararası hub\'ı.',
        'Filo: Dünyanın en büyük A380 ve 777 filolarına sahip. 250+ uçak.',
        'Hizmet: Premium hizmet anlayışı. First Class süitleri, A380 bar ve duş kabinleri ile ünlü.',
        'Slogan: "Fly Emirates" - Basit ama etkili.'
      ],
      keyPoints: [
        'Kuruluş: 1985',
        'Hub: Dubai (DXB)',
        'En büyük A380 operatörü',
        'Premium hizmet'
      ]
    }
  },
  'CM-M12-U1-L2': {
    lesson_id: 'CM-M12-U1-L2',
    title: 'Qatar Airways',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Qatar Airways - Dünyanın En İyisi',
      paragraphs: [
        'Qatar Airways, 1993\'te kuruldu. Katar devletine ait. Skytrax 5 yıldızlı havayolu.',
        'Hub: Hamad Uluslararası Havalimanı (DOH). 2014\'te açıldı, modern tasarım.',
        'Filo: A350, A380, 787 Dreamliner, 777. 200+ uçak.',
        'Oneworld: 2013\'te Oneworld ittifakına katıldı.',
        'Ödüller: "Dünyanın En İyi Havayolu" - Skytrax\'ta defalarca 1. seçildi.'
      ],
      keyPoints: [
        'Kuruluş: 1993',
        'Hub: Doha (DOH)',
        'Oneworld üyesi',
        'Skytrax #1 defalarca'
      ]
    }
  },
  'CM-M12-U1-L3': {
    lesson_id: 'CM-M12-U1-L3',
    title: 'Etihad Airways',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Etihad Airways - Abu Dhabi',
      paragraphs: [
        'Etihad, 2003\'te kuruldu. Birleşik Arap Emirlikleri\'nin ulusal havayolu.',
        'Hub: Abu Dhabi Uluslararası Havalimanı (AUH).',
        'Filo: A380, 787 Dreamliner, 777. Emirates\'ten küçük ama kaliteli.',
        'Özellik: "The Residence" - A380\'deki 3 odalı süit. Dünyanın en lüks uçuş deneyimi.',
        'Yatırımlar: Air Berlin, Alitalia, Jet Airways gibi şirketlere yatırım yaptı.'
      ],
      keyPoints: [
        'Kuruluş: 2003',
        'Hub: Abu Dhabi (AUH)',
        'The Residence süit',
        'İttifak dışı'
      ]
    }
  },
  'CM-M12-U1-L4': {
    lesson_id: 'CM-M12-U1-L4',
    title: 'Körfez Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Emirates hangi şehirde hub?', options: ['Abu Dhabi', 'Dubai', 'Doha', 'Riyad'], correct: 1 },
        { q: 'Qatar Airways hangi ittifakta?', options: ['Star Alliance', 'SkyTeam', 'Oneworld', 'Hiçbiri'], correct: 2 },
        { q: 'Etihad\'in lüks süitinin adı?', options: ['First Suite', 'The Residence', 'Diamond Class', 'Royal Suite'], correct: 1 },
        { q: 'Hangisi en eski Körfez havayolu?', options: ['Emirates', 'Qatar', 'Etihad', 'Gulf Air'], correct: 0 },
        { q: 'Dünyanın en büyük A380 operatörü?', options: ['Qatar', 'Etihad', 'Emirates', 'Singapore'], correct: 2 }
      ]
    }
  },

  // ==================== AVRUPA HAVAYOLLARI ====================
  'CM-M12-U2-L1': {
    lesson_id: 'CM-M12-U2-L1',
    title: 'Lufthansa Group',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Lufthansa - Almanya\'nın Kartalı',
      paragraphs: [
        'Lufthansa, 1953\'te (yeniden) kuruldu. Almanya\'nın bayrak taşıyıcısı.',
        'Hub: Frankfurt (FRA) ve Münih (MUC). Avrupa\'nın en büyük hub\'ı FRA.',
        'Grup Şirketleri: Swiss, Austrian, Brussels Airlines, Eurowings - Hepsi Lufthansa Group.',
        'Star Alliance: Kuruculardan. THY ile aynı ittifakta.',
        'Filo: A350, 787, A380, 747-8. Geniş ve modern filo.'
      ],
      keyPoints: [
        'Kuruluş: 1953',
        'Hub: Frankfurt, Münih',
        'Star Alliance kurucusu',
        'Grup: Swiss, Austrian...'
      ]
    }
  },
  'CM-M12-U2-L2': {
    lesson_id: 'CM-M12-U2-L2',
    title: 'British Airways',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'British Airways - İngiltere\'nin Bayrağı',
      paragraphs: [
        'BA, 1974\'te kuruldu. İngiltere\'nin bayrak taşıyıcısı. IAG grubunun parçası.',
        'Hub: Londra Heathrow (LHR) - Avrupa\'nın en yoğun havalimanı.',
        'IAG: International Airlines Group - BA, Iberia, Aer Lingus, Vueling.',
        'Oneworld: Kuruculardan. American Airlines, Qatar ile ortak.',
        'Concorde: 2003\'e kadar Concorde uçurdu. Havacılık tarihinin efsanesi.'
      ],
      keyPoints: [
        'Kuruluş: 1974',
        'Hub: Londra Heathrow',
        'Oneworld kurucusu',
        'IAG grubunda'
      ]
    }
  },
  'CM-M12-U2-L3': {
    lesson_id: 'CM-M12-U2-L3',
    title: 'Air France-KLM',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Air France-KLM Grubu',
      paragraphs: [
        'Air France: 1933 kuruluş. Fransa\'nın bayrak taşıyıcısı. Hub: Paris CDG.',
        'KLM: 1919 kuruluş - Dünyanın en eski havayolu! Hub: Amsterdam Schiphol (AMS).',
        'Birleşme: 2004\'te Air France ve KLM birleşti. Avrupa\'nın en büyük havayolu grubu oldu.',
        'SkyTeam: Kurucu üye. Delta, Korean Air ile ortak.',
        'Flying Blue: Ortak sadakat programı.'
      ],
      keyPoints: [
        'KLM: 1919 - En eski!',
        'Air France: 1933',
        'Hub: Paris CDG, Amsterdam',
        'SkyTeam kurucusu'
      ]
    }
  },
  'CM-M12-U2-L4': {
    lesson_id: 'CM-M12-U2-L4',
    title: 'Avrupa Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Dünyanın en eski havayolu?', options: ['Lufthansa', 'BA', 'KLM', 'Air France'], correct: 2 },
        { q: 'Lufthansa hangi ittifakta?', options: ['Oneworld', 'SkyTeam', 'Star Alliance', 'Hiçbiri'], correct: 2 },
        { q: 'BA hangi havalimaninda hub?', options: ['Gatwick', 'Heathrow', 'Stansted', 'City'], correct: 1 },
        { q: 'Swiss hangi grubun parçası?', options: ['IAG', 'Lufthansa Group', 'Air France-KLM', 'SAS'], correct: 1 },
        { q: 'SkyTeam\'in kurucusu?', options: ['Lufthansa', 'BA', 'Air France', 'Emirates'], correct: 2 }
      ]
    }
  },

  // ==================== ASYA-PASİFİK ====================
  'CM-M12-U3-L1': {
    lesson_id: 'CM-M12-U3-L1',
    title: 'Singapore Airlines',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Singapore Airlines - Hizmet İkonu',
      paragraphs: [
        'SIA, 1972\'de kuruldu. Singapur\'un bayrak taşıyıcısı. Hizmet kalitesiyle ünlü.',
        'Hub: Changi Havalimanı (SIN) - Dünyanın en iyi havalimanı seçildi defalarca.',
        'Singapore Girl: Kabin ekibi üniforması - sarong kebaya. Havacılığın ikonu.',
        'Filo: A380, 777, A350. En yeni uçakları ilk alan havayollarından.',
        'Star Alliance: Kurucu üye. THY ile aynı ittifak.'
      ],
      keyPoints: [
        'Kuruluş: 1972',
        'Hub: Singapur Changi',
        'Singapore Girl ikonu',
        'Star Alliance kurucusu'
      ]
    }
  },
  'CM-M12-U3-L2': {
    lesson_id: 'CM-M12-U3-L2',
    title: 'Cathay Pacific & ANA',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Cathay Pacific ve ANA',
      paragraphs: [
        'Cathay Pacific: 1946 kuruluş. Hong Kong merkezli. Oneworld üyesi.',
        'Hub: Hong Kong (HKG). Asya\'nın önemli transit noktası.',
        'ANA (All Nippon Airways): 1952 kuruluş. Japonya\'nın en büyük havayolu.',
        'ANA Hub: Tokyo Haneda (HND) ve Narita (NRT).',
        'ANA Özellik: Star Alliance üyesi. 787\'nin lansman müşterisi.'
      ],
      keyPoints: [
        'Cathay: Hong Kong, Oneworld',
        'ANA: Tokyo, Star Alliance',
        'Cathay: 1946',
        'ANA: 787 lansman müşterisi'
      ]
    }
  },
  'CM-M12-U3-L3': {
    lesson_id: 'CM-M12-U3-L3',
    title: 'Asya Quiz',
    type: 'quiz',
    duration: 5,
    xp: 35,
    quiz: {
      questions: [
        { q: 'Singapore Airlines hangi ittifakta?', options: ['Oneworld', 'SkyTeam', 'Star Alliance', 'Hiçbiri'], correct: 2 },
        { q: 'Cathay Pacific nerede hub?', options: ['Singapur', 'Tokyo', 'Hong Kong', 'Pekin'], correct: 2 },
        { q: 'ANA hangi ülkenin havayolu?', options: ['Çin', 'Kore', 'Japonya', 'Tayland'], correct: 2 },
        { q: 'Changi Havalimanı nerede?', options: ['Hong Kong', 'Singapur', 'Tokyo', 'Seul'], correct: 1 }
      ]
    }
  },

  // ==================== AMERİKA ====================
  'CM-M12-U4-L1': {
    lesson_id: 'CM-M12-U4-L1',
    title: 'ABD Big Three',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Amerikan Havayolları - Big 3',
      paragraphs: [
        'American Airlines: Dünyanın en büyük havayolu (filo ve gelir). Hub: Dallas (DFW), Miami.',
        'Delta Air Lines: 2. büyük. Hub: Atlanta (ATL) - Dünyanın en yoğun havalimanı.',
        'United Airlines: 3. büyük. Hub: Chicago O\'Hare (ORD), Newark (EWR).',
        'İttifaklar: American = Oneworld, Delta = SkyTeam, United = Star Alliance.',
        'Özellik: İç pazar dev. Uzun mesafede Avrupa ve Asya hatları güçlü.'
      ],
      keyPoints: [
        'American: Oneworld, Dallas',
        'Delta: SkyTeam, Atlanta',
        'United: Star Alliance, Chicago',
        'Atlanta en yoğun hub'
      ]
    }
  },
  'CM-M12-U4-L2': {
    lesson_id: 'CM-M12-U4-L2',
    title: 'Amerika Quiz',
    type: 'quiz',
    duration: 5,
    xp: 35,
    quiz: {
      questions: [
        { q: 'Dünyanın en büyük havayolu?', options: ['Emirates', 'Delta', 'American', 'United'], correct: 2 },
        { q: 'Delta hangi ittifakta?', options: ['Oneworld', 'SkyTeam', 'Star Alliance', 'Hiçbiri'], correct: 1 },
        { q: 'En yoğun ABD havalimanı?', options: ['JFK', 'LAX', 'Atlanta', 'Chicago'], correct: 2 },
        { q: 'United hangi ittifakta?', options: ['Oneworld', 'SkyTeam', 'Star Alliance', 'Hiçbiri'], correct: 2 }
      ]
    }
  },
};

export default cabinCrewContentsM12;
